export class StartTime {
  hour: number;
  fromTime: Date;
  toTime: Date;
  checked: boolean;
}
